import React, { useState } from 'react';
import { Box, Stack, TextField, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

export default function TimeRangePicker({
                                            value = { start: null, end: null },
                                            onChange = () => {},
                                            minutesStep = 5,
                                            minTime = null,
                                            maxTime = null,
                                            labelStart = 'Kezdete',
                                            labelEnd = 'Vége',
                                            disabled = false,
                                        }) {
    const [startTime, setStartTime] = useState(value.start ? dayjs(value.start, 'HH:mm') : null);
    const [endTime, setEndTime] = useState(value.end ? dayjs(value.end, 'HH:mm') : null);

    const handleStartChange = (newValue) => {
        if (!newValue || !newValue.isValid()) {
            setStartTime(null);
            onChange({ start: null, end: endTime ? endTime.format('HH:mm') : null });
            return;
        }

        setStartTime(newValue);

        if (endTime && newValue.isAfter(endTime)) {
            setEndTime(newValue);
            onChange({ start: newValue.format('HH:mm'), end: newValue.format('HH:mm') });
        } else {
            onChange({ start: newValue.format('HH:mm'), end: endTime ? endTime.format('HH:mm') : null });
        }
    };

    const handleEndChange = (newValue) => {
        if (!newValue || !newValue.isValid()) {
            setEndTime(null);
            onChange({ start: startTime ? startTime.format('HH:mm') : null, end: null });
            return;
        }

        setEndTime(newValue);

        if (startTime && newValue.isBefore(startTime)) {
            setStartTime(newValue);
            onChange({ start: newValue.format('HH:mm'), end: newValue.format('HH:mm') });
        } else {
            onChange({ start: startTime ? startTime.format('HH:mm') : null, end: newValue.format('HH:mm') });
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack direction="row" spacing={2} alignItems="center">
                <Box>
                    <Typography variant="body2">{labelStart}</Typography>
                    <TimePicker
                        ampm={false}
                        disabled={disabled}
                        value={startTime}
                        onChange={handleStartChange}
                        minutesStep={minutesStep}
                        minTime={minTime ? dayjs(minTime, 'HH:mm') : undefined}
                        maxTime={endTime || maxTime ? dayjs(endTime || maxTime, 'HH:mm') : undefined}
                        renderInput={(params) => <TextField variant='standard' {...params} />}
                    />
                </Box>
                <Box>
                    <Typography variant="body2">{labelEnd}</Typography>
                    <TimePicker
                        ampm={false}
                        disabled={disabled}
                        value={endTime}
                        onChange={handleEndChange}
                        minutesStep={minutesStep}
                        minTime={startTime || minTime ? dayjs(startTime || minTime, 'HH:mm') : undefined}
                        maxTime={maxTime ? dayjs(maxTime, 'HH:mm') : undefined}
                        renderInput={(params) => <TextField variant='standard' {...params} />}
                    />
                </Box>
            </Stack>
        </LocalizationProvider>
    );
}
